import { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function CommonButton(props: any) {
    const [isEnter, setIsEnter] = useState(false);
    useEffect(() => {
        if (!props.disabledAni) {
            const scene = new ScrollMagic.Scene({
                triggerElement: '.nb-btn',
                offset: props.startOffsest || 350, //从开始点滚动多少px触发,可为负数
                triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
                duration: '100%',
            });
            scene.on('enter', () => {
                setIsEnter(true);
            });
            controllerDay.addScene(scene);
            return () => {
                scene && scene?.destroy();
            };
        }
    }, []);

    const handleClick = () => {
        props.onClick && props.onClick();
    };

    return (
        <div className={`${styles.nbBtn} nb-btn`} onClick={handleClick}>
            <div
                style={{
                    padding: `${props?.border || '2px'}`,
                    position: 'relative',
                    borderRadius: `${props?.borderRadius || '1.3em'}`,
                    display: 'inline-block',
                    overflow: 'hidden',
                    fontSize: `${props?.fontSize || '24px'}`,
                }}
            >
                <div
                    style={{
                        width: '100%',
                        paddingBottom: '100%',
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                        top: '50%',
                        left: '50%',
                    }}
                    className={`nb-base ${!props.disabledAni && isEnter && !props.isLoop ? 'nb-bg' : ''} ${
                        !props.disabledAni && isEnter && props.isLoop ? 'loop-bg' : ''
                    }`}
                ></div>
                <div
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        padding: `${props?.padding || '0px 20px'}`,
                        lineHeight: `${props?.lineHeight || '0'}`,
                        backgroundColor: `${props?.bgColor || '#000'}`,
                        borderRadius: `${props?.borderRadius || '1.3em'}`,
                        color: '#fff',
                    }}
                >
                    {props.children || props.text || 'click button'}
                </div>
            </div>
        </div>
    );
}
